// extracted by mini-css-extract-plugin
export var blue = "_3a-g";
export var brand = "_3a-c";
export var darkGrey = "_3a-f";
export var disabled = "_3a-6";
export var disabledSubtle = "_3a-7";
export var error = "_3a-8";
export var green = "_3a-h";
export var grey = "_3a-e";
export var icon = "_3a-0";
export var inherit = "_3a-b";
export var lightGrey = "_3a-d";
export var orange = "_3a-j";
export var pink = "_3a-l";
export var primary = "_3a-1";
export var purple = "_3a-m";
export var quaternary = "_3a-4";
export var quinary = "_3a-5";
export var red = "_3a-k";
export var secondary = "_3a-2";
export var success = "_3a-a";
export var tertiary = "_3a-3";
export var warning = "_3a-9";
export var white = "_3a-n";
export var yellow = "_3a-i";